import { API } from '@aws-amplify/api'
import { WOMA_API_GATEWAY_NAME } from '../../constants/aws'
import {
  getPDFBytes,
  saveDraftReport,
  setDraftReportData,
  setReportDiagnosisData,
  setCategorizedData,
  setReportData,
  setSignedUrlToGetReport,
  setSignedUrlToGetTrf,
  setCaseDiagnosis,
  setURLForReportPDF,
  getSaveState,
} from '../actions'

export const clearPremerisReportApiCache = () => async (dispatch) => {
  await dispatch(setDraftReportData({ payload: {} }))
  await dispatch(setCaseDiagnosis({ payload: {} }))
}

export const getReportData =
  ({ trfBarcode, procedureCode }) =>
  async (dispatch) => {
    const apiName = '/premeris/reportInfo/getReportData'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}/${procedureCode}`, options)
      await dispatch(setReportData({ payload: result }))
    } catch (err) {
      console.log('getReportData Error', err)
    }
  }

export const addListData = (list, isReorder) => async (dispatch) => {
  const categories = [] as any
  let categorizedList = {} as any
  const flatList = [] as any
  if (Array.isArray(list) && list.length) {
    list.map((item) => {
      categories.push(item.category)
    })
    const uniqueCategories = categories.filter((value, index, array) => array.indexOf(value) === index)
    for (let i = 0; i < uniqueCategories.length; i++) {
      const categoryList = [] as any
      list.map((item, index) => {
        if (item.category === uniqueCategories[i]) {
          categoryList.push(item)
        }
      })
      categorizedList[uniqueCategories[i]] = categoryList
    }
  } else if (list != null && typeof list == 'object' && list.length) {
    categorizedList = list
    Object.keys(list).map((key) => {
      if (list[key].length) {
        list[key].map((item) => {
          flatList.push(item)
        })
      }
    })
    list = flatList
  }
  await dispatch(setCategorizedData({ payload: categorizedList }))
  if (isReorder) {
    await dispatch(setReportDiagnosisData({ payload: list }))
  }
}

export const setPDFBytes =
  ({ pdfUrl }) =>
  async (dispatch) => {
    await dispatch(getPDFBytes({ payload: pdfUrl }))
  }

export const setDraftEmpty =
  ({ draft }) =>
  async (dispatch) => {
    await dispatch(setDraftReportData({ payload: draft }))
  }
export const getDraftReportData =
  ({ trfBarcode }) =>
  async (dispatch) => {
    const apiName = '/premeris/reportInfo/getDraftReportData'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}`, options)
      const reportData = result.reportBuilder
      Object.keys(reportData).map((location) => {
        Object.keys(reportData[location]).map((reportOption) => {
          if (reportOption === 'caseDiagnosis') {
            reportData[location]['Case Diagnosis'] = reportData[location][reportOption]
          } else if (reportOption === 'comments') {
            reportData[location]['Comments'] = reportData[location][reportOption]
          } else {
            reportData[location][reportOption] = reportData[location][reportOption]
          }
        })
      })
      result.reportBuilder = reportData
      await dispatch(setDraftReportData({ payload: result }))
    } catch (err) {
      console.log('getDraftReportData Error', err)
    }
  }

export const saveDraftReportData =
  ({ trfBarcode, calloutDecision, consultedPats, reportBuilder }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/premeris/reportInfo/saveDraftReportData'
    try {
      const data = {
        trfBarcode: trfBarcode,
        calloutDecision: calloutDecision,
        consultedPats: consultedPats,
        reportBuilder: reportBuilder,
      }
      const options = {
        headers: {},
        response: false,
        body: { draftJSON: data },
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}`, options)
      if (result) {
        action = 'SAVE_REPORT_DRAFT_SUCCESS'
      }
    } catch (err) {
      action = 'SAVE_REPORT_DRAFT_ERROR'
      console.log('saveDraftReportData Error', err)
    } finally {
      await dispatch(saveDraftReport({ action: action }))
    }
  }

export const getSignedUrlToGetReport =
  ({ url }) =>
  async (dispatch) => {
    const apiName = '/premeris'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}${url}`, options)
      if (result) {
        dispatch(setSignedUrlToGetReport({ payload: result }))
      }
      return result
    } catch (err) {
      console.log('getSignedUrlToGetReport Error', err)
    }
  }

export const getURLForReportPDF =
  ({ trfBarcode }) =>
  async (dispatch) => {
    const apiName = '/premeris/reportInfo/getURLForReportPDF'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}`, options)
      if (result) {
        dispatch(setURLForReportPDF({ payload: result }))
      }
    } catch (err) {
      console.log('getURLForReportPDF Error', err)
    }
  }

export const getSignedUrlToGetTrf =
  ({ url }) =>
  async (dispatch) => {
    const apiName = '/premeris'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}${url}`, options)
      if (result) {
        dispatch(setSignedUrlToGetTrf({ payload: result }))
      }
      return result
    } catch (err) {
      console.log('getSignedUrlToGetTrf Error', err)
    }
  }

/* export const getPDFTemplate =
  ({ procedureCode }) =>
  async (dispatch) => {
    const apiName = '/premeris/reportInfo/GetSignedURLForPDFTemplate/' + procedureCode + '/1'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      await dispatch(setPDFTemplate({ payload: result }))
    } catch (err) {
      console.log('getPDFTemplate Error', err)
    }
  } */

export const getPDFPreview =
  ({ consultLP, data, isRelease, locations, pathologistName, pathologistId, pdfLocationInfo, practiceInfo, reason }) =>
  async (dispatch) => {
    const apiName = 'case-management/pdf/generate-report-pdf'
    const body = {
      consultLP: consultLP,
      data: data,
      isRelease: isRelease ? true : false,
      locations: locations,
      pathologistName: pathologistName,
      pathologistId: pathologistId,
      pdfLocationInfo: pdfLocationInfo,
      practiceInfo: practiceInfo,
      reason: reason,
    }
    try {
      const options = {
        body: body,
        headers: {},
        response: true,
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `/${apiName}`, options)
      if (result?.data) {
        dispatch(setPDFBytes({ pdfUrl: result.data }))
      }
    } catch (err) {
      console.log('getPDFPreview Error', err)
    }
  }

export const getCaseDiagnosis =
  ({ procedureCode }) =>
  async (dispatch) => {
    const apiName = '/case-management/pathologist/getCaseDiagnosisOptions/' + procedureCode
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      await dispatch(setCaseDiagnosis({ payload: result }))
    } catch (err) {
      console.log('getCaseDiagnosis Error', err)
    }
  }

export const setSaveState =
  ({ isSaveDisabled }) =>
  async (dispatch) => {
    await dispatch(getSaveState({ payload: isSaveDisabled }))
  }
